import { bool } from "prop-types";

import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrFade from "UI/FnrFade";
import FnrHelpEmailLink from "UI/FnrHelpEmailLink/FnrHelpEmailLink";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

const FnrHelpInvitation = ({ showLogo }) => {
  return (
    <FnrHorizontalGap gap={4} data-cy="FnrHelpInvitation_Container">
      <FnrFade show={showLogo} top={false} left>
        <FnrContainedIcon
          icon="uno"
          color="fnBlue"
          data-cy="FnrHelpInvitation_Icon"
        />
      </FnrFade>
      <FnrTypography type="copy">
        Need help? Email <FnrHelpEmailLink />.
      </FnrTypography>
    </FnrHorizontalGap>
  );
};

FnrHelpInvitation.propTypes = { showLogo: bool };

export default FnrHelpInvitation;
